export const MODAL_BASIC_PROPS = {
  contentPosition: "center--center",
  inSceneEffect: "fadeIn",
  outSceneEffect: "fadeOut",
  opacityLayoutColor: "darkblue",
  closeByClickingOutside: true,
};

export const MODAL_BASIC_PROPS_HBO = {
  contentPosition: "right--center",
  inSceneEffect: "fadeIn",
  outSceneEffect: "fadeOut",
  opacityLayoutColor: "darkblue",
  closeByClickingOutside: true,
};

export const MODAL_LATERAL_RIGHT_PROPS = {
  contentPosition: "right--center",
  inSceneEffect: "fadeIn",
  outSceneEffect: "fadeOut",
  opacityLayoutColor: "darkblue",
  closeByClickingOutside: true,
};

export const MODAL_BASIC_PROPS_MOBILE = {
  contentPosition: "center--bottom",
  inSceneEffect: "fadeInBottom",
  outSceneEffect: "fadeOutBottom",
  opacityLayoutColor: "darkblue",
  closeByClickingOutside: true,
};

export const MODAL_SIDE_CENTER_PROPS = {
  contentPosition: "center--center",
  inSceneEffect: "fadeInBottom",
  outSceneEffect: "fadeOutBottom",
  opacityLayoutColor: "darkblue",
  closeByClickingOutside: true,
};

export const MODAL_ALL_LINES = "SelectLineModal";
export const MODAL_SERVICE = "ServiceManagmentModal";
export const MODAL_GAME_PASS_CODE = "GamePassCodeModal";

export const SERVICE_ROUTER = "router";
export const SERVICE_WHATSAPP = "whatsapp";
export const SERVICE_TEST = "test";
export const SERVICE_OCULTACION = "ocultacion";

export const SERVICE_EXTRA_DATA = "datos-extra";

export const SERVICE_SHARED_DATA = "Datos compartidos";

export const MODAL_LEGAL_PROVIDER = "condiciones-legales"

export const TITLE_OK_MODAL_APPOINTMENT = "La cita ha sido cambiada"
export const TITLE_OK_MODAL_APPOINTMENT_BOX = "Instalación"
export const TITLE_OK_MODAL_APPOINTMENT_LINK_LABEL_CO = "Volver a mis pedidos";
export const TITLE_OK_MODAL_APPOINTMENT_LINK_LABEL_CP = "Volver";
export const OK_MODAL_APPOINTMENT_LINK_CO = "https://www.movistar.es/area-cliente/mi-perfil/seguimiento-de-pedidos/"
export const OK_MODAL_APPOINTMENT_LINK_CP = "https://www.movistar.es/area-cliente/soporte/"

export const URL_SMART_WIFI =
  "/area-cliente/mis-productos/smart-wifi";

  export const URL_SMART_WIFI_BUTTON =
  "https://www.movistar.es/area-cliente/mis-productos/smart-wifi";

  export const MIN_VALUE = 5;
  export const MAX_VALUE = 30;
  export const STEP = 5;
